import { forwardRef } from 'react';

import { GridRowProps } from '@hh.ru/magritte-ui-grid/types';
import { genCssVarRowGap } from '@hh.ru/magritte-ui-grid/utils';

import styles from './row.less';

export const GridRow = forwardRef<HTMLDivElement, GridRowProps>(({ children, rowGap, ...props }, ref) => {
    const cssVar = genCssVarRowGap({ rowGap });
    return (
        <div {...props} className={styles['grid-row']} style={cssVar} ref={ref}>
            {children}
        </div>
    );
});

GridRow.displayName = 'GridRow';
